// contact-form.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IContactDetails } from 'src/app/core/models/contactDetails.interface';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: []
})
export class ContactComponent implements OnInit {
  contactFormGroup!: FormGroup<any>;
  @Input() newContact: boolean = false;
  @Input() set contactDetailFormGroup(form: FormGroup){
    if(form){
      console.log(form.value);
      this.contactFormGroup = form;
    }
  };
  @Input() listOfContacts: IContactDetails[] = [];
  @Input() showContactList: boolean = true;
  @Output() contactDetailFormGroupChange = new EventEmitter<FormGroup>();
  @Output() newFormSubmit = new EventEmitter<any>();
  listOfTitles: string[] = [
    'Mr',
    'Mrs',
    'Ms',
  ];
  isContactLoading: boolean = false;
  selectedAuthoriserPerson: any;

  constructor(private modalService:NgbModal) { }

  ngOnInit() {
    this.contactFormGroup.valueChanges.subscribe(() => {
      this.contactDetailFormGroupChange.emit(this.contactFormGroup);
    });
  }

  selectedContact(contact: IContactDetails): void {
    // Reset the form to initial state
    this.contactFormGroup.reset();
    // Set the selected contact details to the form
    this.contactFormGroup.patchValue({
      title: contact.title || null,
      firstName: contact?.id !== 0 ? contact.firstName : '',
      lastName: contact.lastName,
      phone: contact.phone,
      contactEmail: contact.email,
      contactSource: contact?.contactSource || 'USER_PROVIDED'
    });

    // store the selected contact
    this.selectedAuthoriserPerson = contact;
    this.contactDetailFormGroupChange.emit(this.contactFormGroup);
  }

  showForm(): boolean{
    if(this.showContactList){
      return this.listOfContacts?.length === 1 || !!this.selectedAuthoriserPerson;
    }
    return true;
  }

  close(): void{
    this.modalService.dismissAll();
  }

  addContact(): void{
    if(this.contactFormGroup.valid){
      this.newFormSubmit.emit(this.contactFormGroup.value);
    }
    else{
      this.contactFormGroup.markAllAsTouched();
    }
  }
}
